import { Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import axios from "axios";
import { ToastContainer, toast } from "react-toast";
import { withTranslation } from "react-i18next";

//import { createMuiTheme, ThemeProvider } from '@material-ui/core';
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;
function Editcontact(props) {
  const { t } = props;

  const initialValue = {
    //pic: user.photo_poste_interne,
    id: props.contact.id,
    nom_prenom: props.contact.nom_prenom,
    prenom: props.contact.prenom,
    email: props.contact.email,
    adresse: props.contact.adresse,
    tel_portable: props.contact.tel_portable,
    tel_fix: props.contact.tel_fix,
    tel_3: props.contact.tel_3,
    tel_4: props.contact.tel_4,
    tel_5: props.contact.tel_5,
    commentaire: "",
  };
  const showCustom = () =>
    toast("Contact modifié  avec succès", {
      backgroundColor: "#27d0b2",
      color: "#ffffff",
    });
  const saveUser = (values, setStatus, setSubmitting) => {
    const config = {
      headers: {
        Authorization: token,
      },
    };
    const fieldTel = document.getElementById("tel_portable");
    const fieldNom = document.getElementById("nom_prenom");

    if (!values.nom_prenom || !values.tel_portable) {
      if (!values.nom_prenom) {
        fieldNom?.focus();
        fieldNom?.classList.remove("focus:ring-green-500");

        fieldNom?.classList.add("focus:ring-red-500");
      } else {
        fieldTel?.focus();
        fieldTel?.classList.remove("focus:ring-green-500");

        fieldTel?.classList.add("focus:ring-red-500");
      }

      return;
    } else {
      fieldTel?.classList.remove("focus:ring-red-500");
      fieldNom?.classList.remove("focus:ring-red-500");
    }
    const data = new URLSearchParams();
    data.append("compte", compte);
    data.append("poste", poste);
    data.append("action", "update");
    data.append("id", props.contact.id);
    data.append("nom_prenom", values.nom_prenom);
    data.append("prenom", values.prenom);
    data.append("email", values.email);
    data.append("adresse", values.adresse);
    data.append("tel_portable", values.tel_portable);
    data.append("tel_fix", values.tel_fix);
    data.append("tel_3", values.tel_3);
    data.append("tel_4", values.tel_4);
    data.append("tel_5", values.tel_5);
    data.append("commentaire", values.commentaire);

    const url = `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CRUDContactCarnetAdresseIPBXV3API`;

    axios
      .post(url, data, {
        ...config,
        headers: {
          ...config.headers,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })

      .then((res) => {
        props.toggle();
        showCustom();
      })
      .catch((err) => {
        // if (err == "Error: Request failed with status code 401") {
        //   localStorage.clear();
        //   var link = "/";
        //   window.location.replace(link);
        // } else {
        //   setSubmitting(false);
        //   setStatus(err);
        //   toast.error("Ce contact existe déja");
        // }
      });
  };

  const formik = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      console.log(values);
      saveUser(values, setStatus, setSubmitting);
    },
  });
  useEffect(() => {
    formik.resetForm();
  }, [props.showModal]);
  return (
    <Transition.Root show={props.showModal} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        open={true}
        onClose={props.handleClose}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className=" dark:bg-gray-800 dark:text-white inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <ToastContainer delay={3000} position={"top-right"} />
                <button
                  type="button"
                  className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  onClick={props.handleClose}
                >
                  <span className="sr-only">Close</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="sm:flex sm:items-start">
                <div className="dark:text-white dark:bg-gray-400 mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                    />
                  </svg>
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <Dialog.Title
                    as="h3"
                    className="dark:text-white text-lg leading-6 font-medium text-gray-900"
                  >
                    {t("editcontact")}
                  </Dialog.Title>
                </div>
              </div>
              <div className="mt-10 sm:mt-0">
                <div className="mt-5 md:mt-0 md:col-span-1">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="overflow-hidden sm:rounded-md">
                      <div className="px-4 py-5 bg-white sm:p-6 dark:bg-gray-800 dark:text-white">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first-name"
                              className="dark:text-white  block text-sm font-medium text-gray-700"
                            >
                              {t("Nom.contact.table")}{" "}
                              <sup className="text-red-500">*</sup>
                            </label>
                            <input
                              id="nom_prenom"
                              {...formik.getFieldProps("nom_prenom")}
                              className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border dark:bg-gray-700"
                            />
                          </div>

                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="last-name"
                              className="dark:text-white  block text-sm font-medium text-gray-700"
                            >
                              {t("Prenom.contact.table")}{" "}
                            </label>
                            <input
                              {...formik.getFieldProps("prenom")}
                              className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border dark:bg-gray-700"
                            />
                          </div>

                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="last-name"
                              className="dark:text-white  block text-sm font-medium text-gray-700"
                            >
                              Mobile
                              <sup className="text-red-500">*</sup>
                            </label>

                            <input
                              id="tel_portable"
                              {...formik.getFieldProps("tel_portable")}
                              onChange={(e) => {
                                const value = e.target.value.trim();
                                if (/^\+?\d*$/.test(value)) {
                                  formik.setFieldValue("tel_portable", value);
                                }
                              }}
                              inputMode="tel"
                              pattern="^\+?\d*$"
                              className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border dark:bg-gray-700"
                            />
                          </div>

                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="email-address"
                              className="dark:text-white  block text-sm font-medium text-gray-700"
                            >
                              E-mail
                            </label>
                            <input
                              //defaultValue={this.props.contact.email}
                              // value={contact.email}
                              // type="text"
                              // name="email"
                              // id="email"
                              // onChange={onChangeUserEmail}
                              // autoComplete="email"
                              {...formik.getFieldProps("email")}
                              className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border dark:bg-gray-700"
                            />
                          </div>

                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="street-address"
                              className="dark:text-white  block text-sm font-medium text-gray-700"
                            >
                              {t("adress.contact.table")}
                            </label>
                            <input
                              //defaultValue={this.props.contact.adresse}
                              // value={contact.adresse}
                              // type="text"
                              // name="adresse"
                              // id="adresse"
                              // onChange={onChangeUserAdresse}
                              // autoComplete="street-address"
                              {...formik.getFieldProps("adresse")}
                              className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border dark:bg-gray-700"
                            />
                          </div>

                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="city"
                              className="dark:text-white block text-sm font-medium text-gray-700"
                            >
                              {t("tel")} n°2
                            </label>
                            <input
                              // defaultValue={this.props.contact.tel_fix}
                              // value={contact.tel_fix}
                              // type="text"
                              // name="tel_fix"
                              // id="tel_fix"
                              // onChange={onChangeUserTelfix}
                              {...formik.getFieldProps("tel_fix")}
                              className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border dark:bg-gray-700"
                            />
                          </div>

                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="state"
                              className="dark:text-white block text-sm font-medium text-gray-700"
                            >
                              {t("tel")} n°3
                            </label>
                            <input
                              //defaultValue={this.props.contact.tel_3}
                              // value={contact.tel_3}
                              // type="text"
                              // name="tel_3"
                              // id="tel_3"
                              // onChange={onChangeUserTel3}
                              {...formik.getFieldProps("tel_3")}
                              className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border dark:bg-gray-700"
                            />
                          </div>

                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="postal-code"
                              className="dark:text-white block text-sm font-medium text-gray-700"
                            >
                              {t("tel")} n°4
                            </label>
                            <input
                              //defaultValue={this.props.contact.tel_4}
                              // value={contact.tel_4}
                              // type="text"
                              // name="tel_4"
                              // id="tel_4"
                              // onChange={onChangeUserTel4}
                              // autoComplete="postal-code"
                              {...formik.getFieldProps("tel_4")}
                              className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border dark:bg-gray-700"
                            />
                          </div>
                        </div>
                        <div className="flex items-center  mt-8 justify-between">
                          <p className="col-span-6 text-red-500 sm:col-span-3">
                            * Champs obligatoires !
                          </p>

                          <div className="px-6 py-4  sm:px-6">
                            <button
                              // value="Enregistrer"
                              type="submit"
                              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                            >
                              {t("save")}
                              {/* {formik.isSubmitting} */}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
export default withTranslation("common")(Editcontact);
